import React, { memo } from "react";
import SearchIcon from "@images/icons/search.inline.svg";
import FlagIcon from "@images/icons/flag.inline.svg";
import Logo from "@images/icons/logo.inline.svg";
import LogoSquare from "@images/icons/logo_square.inline.svg";
import Email from "@images/icons/email.inline.svg";
import Phone from "@images/icons/phone.inline.svg";
import Tool from "@images/icons/tool.inline.svg";
import USFlag from "@images/icons/united-states.inline.svg";
import Facebook from "@images/icons/facebook.inline.svg";
import Twitter from "@images/icons/twitter.inline.svg";
import Linkedin from "@images/icons/linkedin.inline.svg";
import Youtube from "@images/icons/youtube.inline.svg";
import Database from "@images/icons/s_database.inline.svg";
import Encrypted from "@images/icons/s_encrypted.inline.svg";
import Lock from "@images/icons/s_lock.inline.svg";
import Download from "@images/icons/download.inline.svg";
import DownloadBrochure from "@images/icons/o_download_brochure.inline.svg";
import DownloadDiagram from "@images/icons/o_download_diagram.inline.svg";
import RequestDemo from "@images/icons/o_request_a_demo.inline.svg";
import ViewInstallation from "@images/icons/o_view_installation.inline.svg";
import SupportKnowledge from "@images/icons/support_knowledge_icon.inline.svg";
import SupportSecurity from "@images/icons/support_security_icon.inline.svg";
import PlayVideo from "@images/icons/play.inline.svg";
import NeedHelpCheck from "@images/icons/need_help_check.inline.svg";
import NeedHelpSupport from "@images/icons/need_help_support.inline.svg";
import { Box } from "@chakra-ui/react";

export type IconListKey =
  | "search"
  | "flag"
  | "logo"
  | "email"
  | "phone"
  | "tool"
  | "USFlag"
  | "facebook"
  | "twitter"
  | "linkedin"
  | "youtube"
  | "s_database"
  | "s_encrypted"
  | "s_lock"
  | "download"
  | "downloadBrochure"
  | "downloadDiagram"
  | "requestDemo"
  | "viewInstallation"
  | "support_knowledge_icon"
  | "support_security_icon"
  | "playVideo"
  | "logoSquare"
  | "needHelpCheck"
  | "needHelpSupport";

export type IIconList = {
  [key in IconListKey]: { component: JSX.Element };
};

const iconsList: IIconList = {
  search: { component: <SearchIcon /> },
  flag: { component: <FlagIcon /> },
  logo: { component: <Logo /> },
  logoSquare: { component: <LogoSquare /> },
  email: { component: <Email /> },
  phone: { component: <Phone /> },
  tool: { component: <Tool /> },
  USFlag: { component: <USFlag /> },
  facebook: { component: <Facebook /> },
  twitter: { component: <Twitter /> },
  linkedin: { component: <Linkedin /> },
  youtube: { component: <Youtube /> },
  s_database: { component: <Database /> },
  s_encrypted: { component: <Encrypted /> },
  s_lock: { component: <Lock /> },
  download: { component: <Download /> },
  downloadBrochure: { component: <DownloadBrochure /> },
  downloadDiagram: { component: <DownloadDiagram /> },
  requestDemo: { component: <RequestDemo /> },
  viewInstallation: { component: <ViewInstallation /> },
  support_knowledge_icon: { component: <SupportKnowledge /> },
  support_security_icon: { component: <SupportSecurity /> },
  playVideo: { component: <PlayVideo /> },
  needHelpCheck: { component: <NeedHelpCheck /> },
  needHelpSupport: { component: <NeedHelpSupport /> },
};

interface IconProps {
  name: string;
  size?: string;
  [x: string]: any;
}

const Icon = (props: IconProps) => {
  const { name, size, ...restProps } = props;

  return (
    <Box {...restProps}>{iconsList[name as keyof IIconList].component}</Box>
  );
};

Icon.defaultProps = {
  type: "search",
};

export default memo(Icon);
